import React from "react";
import {
  FaSearch,
  FaFileInvoiceDollar,
  FaCloudUploadAlt,
  FaCheckCircle,
  FaMobileAlt,
} from "react-icons/fa";
import { StepCard } from "../components/StepCard";

export const ComoFuncionaView = ({ setView }) => (
  <div className="max-w-7xl mx-auto px-4 py-32 animate-fade-in">
    <div className="text-center mb-16">
      <h2 className="text-4xl font-extrabold text-blue-900">
        ¿Cómo Funciona el Sistema?
      </h2>
      <p className="mt-4 text-xl text-gray-500">
        Un proceso sencillo diseñado para la comodidad de todos los socios.
      </p>
    </div>
    <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
      <StepCard
        icon={FaSearch}
        step="01"
        title="Consulta"
        desc="Ingresa tu código de medidor y cédula de identidad en nuestro portal público."
      />
      <StepCard
        icon={FaFileInvoiceDollar}
        step="02"
        title="Revisión"
        desc="Visualiza tus meses pendientes y el detalle de tu consumo."
      />
      <StepCard
        icon={FaCloudUploadAlt}
        step="03"
        title="Pago"
        desc="Realiza el pago del valor pendiente el dia de cobros."
      />
      <StepCard
        icon={FaCheckCircle}
        step="04"
        title="Validación"
        desc="El tesorero valida tu pago y recibes tu comprobante digital."
      />
    </div>
    <div className="mt-16 bg-blue-900 rounded-[40px] p-12 text-center text-white">
      <FaMobileAlt className="text-6xl mx-auto mb-6 text-cyan-400" />
      <h3 className="text-2xl font-bold mb-4">Todo desde tu celular</h3>
      <p className="text-blue-200 mb-8 max-w-2xl mx-auto font-light">
        Nuestra plataforma es totalmente responsiva. No necesitas instalar nada,
        funciona directamente en tu navegador.
      </p>
      <button
        onClick={() => setView("consultas")}
        className="bg-cyan-400 text-blue-900 px-10 py-4 rounded-full font-bold shadow-xl hover:bg-cyan-300 transition-all"
      >
        Probar ahora
      </button>
    </div>
  </div>
);
